export class tableItem {
	constructor() {
		this.name = null;
		this.friendlyName = null;
		this.configs = 0;
	}
	friendlyName: string;
	name: string;
	configs: number;
}
